import ContentLoader from 'react-content-loader';

import COLORS from '../../../../theme/colors';

/**
 * Draws a content loader while the drawer is loading.
 */
const DrawerLoading = () => (
  <ContentLoader
    speed={2}
    width={560}
    height={700}
    foregroundColor={COLORS.fossaGray20}
    backgroundColor={COLORS.fossaGray10}
  >
    {/* Header: Package Name and Version */}
    <rect x="20" y="20" rx="4" ry="4" width="250" height="28" />
    <rect x="20" y="52" rx="3" ry="3" width="350" height="16" />

    {/* Buttons: Reject, Download Match Data */}
    <rect x="20" y="88" rx="4" ry="4" width="80" height="32" />
    <rect x="110" y="88" rx="4" ry="4" width="150" height="32" />

    {/* Tabs: Details, Compare Code */}
    <rect x="20" y="140" rx="0" ry="0" width="60" height="24" />
    <rect x="90" y="140" rx="0" ry="0" width="100" height="24" />
    <rect x="0" y="172" rx="0" ry="0" width="100%" height="1" />

    {/* Package Summary - Section Title */}
    <rect x="20" y="200" rx="3" ry="3" width="200" height="20" />
    {/* Package Summary - 5 rows */}
    <rect x="20" y="230" rx="3" ry="3" width="150" height="14" />
    <rect x="400" y="230" rx="3" ry="3" width="120" height="14" />
    <rect x="20" y="250" rx="3" ry="3" width="150" height="14" />
    <rect x="400" y="250" rx="3" ry="3" width="120" height="14" />
    <rect x="20" y="270" rx="3" ry="3" width="150" height="14" />
    <rect x="400" y="270" rx="3" ry="3" width="120" height="14" />
    <rect x="20" y="290" rx="3" ry="3" width="150" height="14" />
    <rect x="400" y="290" rx="3" ry="3" width="120" height="14" />
    <rect x="20" y="310" rx="3" ry="3" width="150" height="14" />
    <rect x="400" y="310" rx="3" ry="3" width="120" height="14" />

    {/* Match Confidence - Section Title */}
    <rect x="20" y="350" rx="3" ry="3" width="200" height="20" />
    {/* Match Confidence - Confidence Bar */}
    <rect x="20" y="380" rx="4" ry="4" width="520" height="24" />
    {/* Match Confidence - 7 rows */}
    <rect x="20" y="414" rx="3" ry="3" width="250" height="14" />
    <rect x="450" y="414" rx="3" ry="3" width="70" height="14" />
    <rect x="20" y="434" rx="3" ry="3" width="250" height="14" />
    <rect x="450" y="434" rx="3" ry="3" width="70" height="14" />
    <rect x="20" y="454" rx="3" ry="3" width="250" height="14" />
    <rect x="450" y="454" rx="3" ry="3" width="70" height="14" />
    <rect x="20" y="474" rx="3" ry="3" width="250" height="14" />
    <rect x="450" y="474" rx="3" ry="3" width="70" height="14" />
    <rect x="20" y="494" rx="3" ry="3" width="250" height="14" />
    <rect x="450" y="494" rx="3" ry="3" width="70" height="14" />
    <rect x="20" y="514" rx="3" ry="3" width="250" height="14" />
    <rect x="450" y="514" rx="3" ry="3" width="70" height="14" />
    <rect x="20" y="534" rx="3" ry="3" width="250" height="14" />
    <rect x="450" y="534" rx="3" ry="3" width="70" height="14" />

    {/* Licenses - Section Title */}
    <rect x="20" y="574" rx="3" ry="3" width="150" height="20" />
    {/* Licenses - Assuming 4 rows */}
    <rect x="20" y="604" rx="3" ry="3" width="220" height="14" />
    <rect x="260" y="604" rx="3" ry="3" width="130" height="14" />
    <rect x="410" y="604" rx="3" ry="3" width="110" height="14" />

    <rect x="20" y="624" rx="3" ry="3" width="220" height="14" />
    <rect x="260" y="624" rx="3" ry="3" width="130" height="14" />
    <rect x="410" y="624" rx="3" ry="3" width="110" height="14" />

    <rect x="20" y="644" rx="3" ry="3" width="220" height="14" />
    <rect x="260" y="644" rx="3" ry="3" width="130" height="14" />
    <rect x="410" y="644" rx="3" ry="3" width="110" height="14" />

    <rect x="20" y="664" rx="3" ry="3" width="220" height="14" />
    <rect x="260" y="664" rx="3" ry="3" width="130" height="14" />
    <rect x="410" y="664" rx="3" ry="3" width="110" height="14" />

  </ContentLoader>
);

export default DrawerLoading;
